/*
 * Copyright (c) 2025. The content provided herein is protected by copyright law. Unauthorized use, reproduction, or distribution of this material without proper licensing, knowledge, and contract agreement from the author is strictly prohibited. Any infringement of these rights may result in legal action. For inquiries regarding the use of this content, please contact the author for proper authorization and agreement.
 */

import {Translations} from "helpers/config";
import {PackageItemCompetition} from "types/entities/PackageItem";
import {translate} from "utils/utility";

// translate() falls back to the translations object itself, here we only ever want a printable string
export const translatedText = (translations?: Translations | null): string => {
    if (!translations) return "";
    const text = translate(translations);
    return typeof text === "string" && text !== "not found" ? text : "";
};

// name of the option this option depends on, looked up within the options of the same group
export const getDependsOnName = (competition: PackageItemCompetition, groupItems: PackageItemCompetition[]): string => {
    const dependsOnArticleIds = competition.extra.depends_on_article_id ?? [];
    if (dependsOnArticleIds.length === 0) return "";

    const dependsOn = groupItems.find(item => dependsOnArticleIds.includes(item.article_id));
    return dependsOn ? translatedText(dependsOn.name) : "";
};

// distinct category types of the given competitions, e.g. "A" or "A, B"
export const getCategoryTypes = (competitions: {competition: {category_type: string}}[]): string[] => {
    return competitions
        .map(item => (item.competition?.category_type || "").trim().toUpperCase())
        .filter((categoryType, index, all) => categoryType !== "" && all.indexOf(categoryType) === index);
};
